module.exports = "//public.getcloudapp.com/packs/media/images/onboarding/download-chrome-c1e89ede4a531dd325863cb999407114.svg";